import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Label, Input } from "reactstrap";

const DagsDropdown = ({ dag, setDag, dagsList, report }) => (
  <div className="row">
    <div className="col-sm">
      <FormGroup>
        <Label className="builder__label" for="dag">
          DAG:
        </Label>
        <Input
          type="select"
          required
          value={dag}
          onChange={e => setDag(e.target.value)}
          disabled={(dagsList && dagsList.length < 2) || report}
          id="dag"
        >
          <option value="" disabled hidden />
          {dagsList &&
            dagsList.map(item => (
              <option key={item.dagid} value={item.dagid}>
                {item.dagname}
              </option>
            ))}
        </Input>
      </FormGroup>
    </div>
  </div>
);

DagsDropdown.propTypes = {
  dag: PropTypes.string.isRequired,
  setDag: PropTypes.func.isRequired,
  dagsList: PropTypes.array,
  report: PropTypes.object
};

DagsDropdown.defaultProps = {
  dagsList: null,
  report: null
};

export default DagsDropdown;
